import { FilterTextItem } from '../filter.text.item';

export const UUID_FILTER = new FilterTextItem({
  labelKey: 'common:field:uuid',
  field: 'uuid',
});